exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".comfirm-btn[data-v-39da99e4] {\n  padding: 30px 0 0;\n}\n.pagination-wrap[data-v-39da99e4] {\n  text-align: right;\n  padding: 30px 20px;\n}\n", ""]);

// exports
